interface IValidator {
  add(value: any, rules: IRule[], cb?: () => any): void
  start(loopAll?: boolean): string | any[]
}

interface IRule {
  strategy: string
  errMsg: string
  cb?(id): void | undefined
}

const strategies = {
  isNonEmpty(value, errMsg, cb) {
    if (!value) {
      /*tslint:disable*/
      cb && cb()
      return errMsg
    }
  },
  maxLength(value, length, errMsg, cb) {
    if (value.length > length) {
      cb && cb()
      return errMsg
    }
  },
  isMobile(value, errorMsg, cb) {
    if (!/(^1[3|5|8][0-9]{9}$)/.test(value)) {
      cb && cb()
      return errorMsg
    }
  },
  custom(status: boolean, errMsg, cb) {
    if (status) {
      cb && cb()
      return errMsg
    }
  },
}

export default class Validator implements IValidator {
  cache: any[] = []

  public add(value, rules): void {
    for (const rule of rules) {
      const strategyAry = rule.strategy.split(':')

      this.cache.push(() => {
        const strategy = strategyAry.shift()
        strategyAry.unshift(value)
        strategyAry.push(rule.errMsg)
        strategyAry.push(rule.cb)
        return strategies[strategy].apply(null, strategyAry)
      })
    }
  }

  public start(loopAll: boolean): string | any[] {
    if (!loopAll) {
      for (const func of this.cache) {
        const errMsg = func()
        if (errMsg) {
          return errMsg
        }
      }
    } else {
      const errMsgs = []
      for (const func of this.cache) {
        const errMsg = func()
        if (errMsg) {
          errMsgs.push(errMsg)
        }
      }

      return errMsgs
    }
  }
}
